import type { FilterDefinition, FilterValues, FilterWithSelection } from "@/services/filter";

/**
 * Merge filter definitions with current selection state for UI rendering.
 */
export function mergeFiltersWithSelection(definitions: FilterDefinition[], values: FilterValues): FilterWithSelection[] {
  return definitions.map((def) => {
    const val = values[def.slug];
    const selectedValue = Array.isArray(val) ? val : (val ?? null);
    return { ...def, selectedValue };
  });
}
